<template>
  <h4 class="text-theme-content mb-6 font-sans text-xs font-semibold uppercase">
    <slot />
  </h4>
</template>
